module.exports = __webpack_public_path__ + "static/media/willy_b.e7e524c4.svg";